import {CopilotChatIntents, type CopilotChatEventPayload} from '@github-ui/copilot-chat-types'

/**
 * Whether an `open-copilot-chat` payload should be submitted on the user's behalf
 * instead of merely opening the panel.
 */
export function shouldAutoSubmitOpenCopilotChatPayload(
  payload: CopilotChatEventPayload,
): payload is CopilotChatEventPayload & {content: string} {
  // Immersive treats an empty string as content; quick chat refuses to auto-submit empty or whitespace.
  if (!('content' in payload) || typeof payload.content !== 'string' || payload.content.trim().length === 0) {
    return false
  }

  const excluded: readonly string[] = [CopilotChatIntents.discussFileDiff, CopilotChatIntents.reviewPr]
  return !excluded.includes(payload.intent)
}
